import { PlanSelectionStore } from './types';

export const planSelectionStoreSelector = {
  plan: (state: PlanSelectionStore): PlanSelectionStore['plan'] => state.plan,
  disabled: (state: PlanSelectionStore): PlanSelectionStore['disabled'] =>
    state.disabled,
  yearly: (state: PlanSelectionStore): PlanSelectionStore['yearly'] =>
    state.yearly,
  expertAddonPriceId: (
    state: PlanSelectionStore
  ): PlanSelectionStore['expertAddonPriceId'] => state.expertAddonPriceId,
  upgrade: (state: PlanSelectionStore): PlanSelectionStore['upgrade'] =>
    state.upgrade,
  upgradeToExpertPlan: (
    state: PlanSelectionStore
  ): PlanSelectionStore['upgradeToExpertPlan'] => state.upgradeToExpertPlan,
  quantity: (state: PlanSelectionStore): PlanSelectionStore['quantity'] =>
    state.quantity,
  promoCode: (state: PlanSelectionStore): PlanSelectionStore['promoCode'] =>
    state.promoCode,
  actions: (state: PlanSelectionStore): PlanSelectionStore['actions'] =>
    state.actions,
};
